import { render } from "./DialogFormMineur.vue?vue&type=template&id=4b2f1d2c&scoped=true"
import script from "./DialogFormMineur.vue?vue&type=script&lang=js"
export * from "./DialogFormMineur.vue?vue&type=script&lang=js"

import "./DialogFormMineur.vue?vue&type=style&index=0&id=4b2f1d2c&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2f1d2c"]])

export default __exports__